module.exports = __webpack_public_path__ + "static/media/ZW.c5a4202e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/ZW.svg
// module id = 2297
// module chunks = 7